import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const FilterSummary = ({ filters, onClearAll, onRemoveFilter, resultCount }) => {
  const getActiveFilters = () => {
    const activeFilters = [];

    if (filters?.brand) {
      activeFilters?.push({
        key: 'brand',
        label: `Marque: ${filters?.brand}`,
        value: filters?.brand
      });
    }

    if (filters?.model) {
      activeFilters?.push({
        key: 'model',
        label: `Modèle: ${filters?.model}`,
        value: filters?.model
      });
    }

    if (filters?.categories?.length > 0) {
      activeFilters?.push({
        key: 'categories',
        label: `Catégories: ${filters?.categories?.length}`,
        value: filters?.categories
      });
    }

    if (filters?.condition) {
      activeFilters?.push({
        key: 'condition',
        label: `État: ${filters?.condition === 'new' ? 'Neuf' : 'Occasion'}`,
        value: filters?.condition
      });
    }

    if (filters?.minPrice || filters?.maxPrice) {
      const priceLabel = `Prix: ${filters?.minPrice || '0'} - ${filters?.maxPrice || '∞'} FCFA`;
      activeFilters?.push({
        key: 'price',
        label: priceLabel,
        value: { min: filters?.minPrice, max: filters?.maxPrice }
      });
    }

    if (filters?.yearMin || filters?.yearMax) {
      const yearLabel = `Année: ${filters?.yearMin || '1900'} - ${filters?.yearMax || new Date()?.getFullYear()}`;
      activeFilters?.push({
        key: 'year',
        label: yearLabel,
        value: { min: filters?.yearMin, max: filters?.yearMax }
      });
    }

    if (filters?.region) {
      activeFilters?.push({
        key: 'region',
        label: `Région: ${filters?.region}`,
        value: filters?.region
      });
    }

    if (filters?.department) {
      activeFilters?.push({
        key: 'department',
        label: `Département: ${filters?.department}`,
        value: filters?.department
      });
    }

    if (filters?.searchRadius && filters?.searchRadius !== 'all') {
      activeFilters?.push({
        key: 'radius',
        label: `Rayon: ${filters?.searchRadius} km`,
        value: filters?.searchRadius
      });
    }

    if (filters?.sellerType) {
      activeFilters?.push({
        key: 'sellerType',
        label: `Vendeur: ${filters?.sellerType === 'professional' ? 'Professionnel' : 'Particulier'}`,
        value: filters?.sellerType
      });
    }

    return activeFilters;
  };

  const activeFilters = getActiveFilters();

  if (activeFilters?.length === 0) {
    return null;
  }

  return (
    <div className="bg-card border border-border rounded-lg p-4">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center space-x-2">
          <Icon name="Filter" size={18} className="text-primary" />
          <h3 className="font-semibold text-foreground">
            Filtres actifs / Active filters
          </h3>
          {resultCount !== undefined && (
            <span className="text-sm text-muted-foreground">
              ({resultCount?.toLocaleString('fr-FR')} résultats)
            </span>
          )}
        </div>
        
        <Button
          variant="ghost"
          size="sm"
          onClick={onClearAll}
          iconName="X"
          iconPosition="left"
          iconSize={14}
          className="text-destructive hover:text-destructive"
        >
          Tout effacer
        </Button>
      </div>
      <div className="flex flex-wrap gap-2">
        {activeFilters?.map((filter, index) => (
          <div
            key={`${filter?.key}-${index}`}
            className="flex items-center space-x-1 bg-primary/10 border border-primary/20 rounded-full px-3 py-1 text-sm"
          >
            <span className="text-primary font-medium">{filter?.label}</span>
            <button
              onClick={() => onRemoveFilter(filter?.key)}
              className="text-primary hover:text-primary/70 transition-smooth"
            >
              <Icon name="X" size={14} />
            </button>
          </div>
        ))}
      </div>
      {/* Search Summary */}
      <div className="mt-3 pt-3 border-t border-border">
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">
            Recherche dans {filters?.region || 'tout le Cameroun'}
            {filters?.searchRadius && filters?.searchRadius !== 'all' && ` (${filters?.searchRadius} km)`}
          </span>
          {resultCount !== undefined && (
            <span className="font-medium text-success">
              {resultCount?.toLocaleString('fr-FR')} annonces trouvées
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default FilterSummary;